const isFullNameValid = (name) => {
  return name && name.trim().split(" ").length > 1;
}

export { isFullNameValid };
